import { v4 as uuidv4 } from 'uuid';
import { IRelocationLimit } from '@/api';
import { ClientDate } from '@/core/helpers';
import { EditedRelocationLimit } from './EditedRelocationLimit';

export class SaveRelocationLimit
    implements IRelocationLimit {

    public readonly id: string;
    public readonly channelId: string;
    public readonly date: string;
    public readonly duration: string;
    public readonly volume: number | null;
    public readonly weightLimit: number | null;

    constructor(relocationLimit: EditedRelocationLimit) {
        if (!relocationLimit) { throw new Error('relocationLimit is not set'); }
        if (!relocationLimit.channel) { throw new Error('relocationLimit.channel is not set'); }
        if (!relocationLimit.startDate) { throw new Error('relocationLimit.startDate is not set'); }
        if (!relocationLimit.endDate) { throw new Error('relocationLimit.endDate is not set'); }

        // A new Relocation Limit does not have alias. But the backend does not generate aliases,
        // it is necessary to do it here.
        this.id = relocationLimit.id || uuidv4();
        this.channelId = relocationLimit.channel.id;

        this.date = relocationLimit.startDate.toQueryParameter();

        const duration = ClientDate.duration(relocationLimit.startDate, relocationLimit.endDate);
        this.duration = duration.toDto();

        // So volume field value is being set by DevExtreme controls I'm not sure
        // that it has correct 'null' value. Ensure here that we will transfer correct
        // value.
        if (relocationLimit.volume || relocationLimit.volume === 0) {
            this.volume = relocationLimit.volume;
        } else {
            this.volume = null;
        }

        // So weightLimit field value is being set by DevExtreme controls I'm not sure
        // that it has correct 'null' value. Ensure here that we will transfer correct
        // value.
        if (relocationLimit.weightLimit || relocationLimit.weightLimit === 0) {
            this.weightLimit = relocationLimit.weightLimit;
        } else {
            this.weightLimit = null;
        }
    }
}
